define('presentation/signup/facades/signupProfileFacade',[
        'businessServices/signup/signupSessionStore',
        'externalDependencies/clientApi',
        'persistence/webSocket/webSocketApp',
        'presentation/signup/presentationObjects/signupProfilePresentationObject',
    ],
    function() {
        let _promiseFactory = null;
        let _clientApi = null;
        let _signupSessionStore = null;
        let _webSocketApp = null;

        const SignupProfilePresentationObjectConstructor = require('presentation/signup/presentationObjects/signupProfilePresentationObject');

        const _saveFirstName = (firstName) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveFirstName(firstName)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveLastName = (lastName) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveLastName(lastName)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveMobileNumber = (mobileNumber) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveMobileNumber(mobileNumber)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveMobileNumberCountryCode = (mobileNumberCountryCode) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveMobileNumberCountryCode(mobileNumberCountryCode)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveHowDidYouHearAboutUs = (howDidYouHearAboutUs) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveHowDidYouHearAboutUs(howDidYouHearAboutUs)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveHowDidYouHearAboutUsOther = (howDidYouHearAboutUsOther) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveHowDidYouHearAboutUsOther(howDidYouHearAboutUsOther)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _setProfileCompleted = (isProfileCompleted) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _signupSessionStore.setProfileCompleted(isProfileCompleted)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _getEmailStatus = (emailAddress) => {
            return _promiseFactory.defer((promise) => {
                const webSocketParameters = {emailAddress: emailAddress};
                _webSocketApp.send("get_email_address_status", webSocketParameters, (result) => {
                    promise.resolve(result);
                });
            });
        };

        const _isEmailOnAnotherHubSpotContact = (emailAddress) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.get()
                    .fail(promise.reject)
                    .done((signupSession) => {
                        const hubSpotContactRecordId = signupSession.hubSpotContactRecordId;
                        if (!hubSpotContactRecordId) {
                            promise.resolve(true);
                            return;
                        }

                        _signupSessionStore.getHubSpotContactByEmail(emailAddress)
                            .fail(promise.reject)
                            .done((response) => {
                                const { hubSpotContact } = response;
                                if (!hubSpotContact) {
                                    promise.resolve(true);
                                    return;
                                }
                                const hubSpotContactId = hubSpotContact.contactId;
                                promise.resolve(hubSpotContactRecordId === hubSpotContactId);
                            });
                    });
            });
        };

        const _saveEmailAddress = (emailAddress) => _signupSessionStore.saveEmailAddress(emailAddress);

        const _setEmailStepCompleted = (emailAddress, verificationCode) => _signupSessionStore.setEmailCompleted(emailAddress, verificationCode);

        const _isMobilePhoneNumberValid = (phoneNumber) => {
            return _signupSessionStore.isRestrictedPhoneNumber(phoneNumber);
        };

        const _isFraudulentMobileNumber = (phoneNumber, countryCode) => {
            return _signupSessionStore.isFraudulentPhoneNumber(phoneNumber, countryCode);
        };

        const _loadSignupSession = () => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.getState()
                    .fail(promise.reject)
                    .done((signupSession) => {
                        let signupProfilePresentationObject = new SignupProfilePresentationObjectConstructor();
                        signupProfilePresentationObject.emailAddress = signupSession.signupDocument.emailAddress;
                        signupProfilePresentationObject.isEmailStepCompleted = signupSession.signupDocument.isEmailCompleted;
                        signupProfilePresentationObject.firstName = signupSession.signupDocument.firstName;
                        signupProfilePresentationObject.lastName = signupSession.signupDocument.lastName;
                        signupProfilePresentationObject.mobileNumber = signupSession.signupDocument.mobilePhoneNumber;
                        signupProfilePresentationObject.mobileNumberCountryCode = signupSession.signupDocument.mobilePhoneNumberCountry;
                        signupProfilePresentationObject.howDidYouHearAboutUs = signupSession.signupDocument.howDidYouHearAboutUs;
                        signupProfilePresentationObject.howDidYouHearAboutUsOther = signupSession.signupDocument.howDidYouHearAboutUsOther;
                        signupProfilePresentationObject.signupPhoneNumbers = signupSession.headerPhoneNumbers();
                        signupProfilePresentationObject.signupNumberType = signupSession.numberTypeSelection();
                        promise.resolve(signupProfilePresentationObject);
                    });
            });
        };

        const _init = (promiseFactory) => {
            _promiseFactory = promiseFactory;

            const ClientApiConstructor = require('externalDependencies/clientApi');
            _clientApi = new ClientApiConstructor();
            _clientApi.init();

            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
            _signupSessionStore = new SignupSessionStoreConstructor();
            _signupSessionStore.init();

            const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
            _webSocketApp = new WebSocketAppConstructor();
            _webSocketApp.init("validation");
        };


        return function() {
            let self = this;
            self.init = _init;

            self.checkIsFraudulentMobileNumber = _isFraudulentMobileNumber;
            self.getEmailStatus = _getEmailStatus;
            self.isEmailOnAnotherHubSpotContact = _isEmailOnAnotherHubSpotContact;
            self.isMobilePhoneNumberValid = _isMobilePhoneNumberValid;
            self.saveEmailAddress = _saveEmailAddress;
            self.setEmailStepCompleted = _setEmailStepCompleted;
            self.saveFirstName = _saveFirstName;
            self.saveLastName = _saveLastName;
            self.saveHowDidYouHearAboutUs = _saveHowDidYouHearAboutUs;
            self.saveHowDidYouHearAboutUsOther = _saveHowDidYouHearAboutUsOther;
            self.saveMobileNumber = _saveMobileNumber;
            self.saveMobileNumberCountryCode = _saveMobileNumberCountryCode;
            self.setProfileCompleted = _setProfileCompleted;
            self.loadSignupSession = _loadSignupSession;
        };
    });

